<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        label="CRÉER"
        tooltip="Créer une déclinaison de produit"
        (onClick)="openEditObject(produit, undefined)"
        [disabled]="!gds.canModify(produit)">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  class="pt-3"
  [dataSource]="produit.produitDeclinaisons"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(180)"
  width="100%"
  columnResizingMode="widget"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="id" alignment="center" caption="Actions" [width]="200"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="libelle" caption="Libelle"
              cellTemplate="libelleCellTemplate"
              [allowFiltering]="true">
  </dxi-column>

  <dxi-column dataField="declinaison" caption="Déclinaison" [width]="250" cellTemplate="declinaisonCellTemplate">
  </dxi-column>

  <!--  <dxi-column dataField="prixAchat" caption="Prix d'achat" [width]="120"-->
  <!--              cellTemplate="prixAchatCellTemplate"-->
  <!--  >-->
  <!--  </dxi-column>-->

  <dxi-column dataField="uniteDeMesure" caption="Unité technique" [width]="140"
              cellTemplate="uniteDeMesureCellTemplate"
  >
  </dxi-column>


  <dxi-column dataField="code" caption="Code" [width]="140"
  >
  </dxi-column>

  <dxi-column dataField="dlc" caption="DLC" [width]="80"
              cellTemplate="dlcCellTemplate"
  >
  </dxi-column>

  <dxi-column dataField="actif" caption="Actif" [width]="80"
  >
  </dxi-column>

  <!--  EXCEL EXPORT-->
  <dxo-export [enabled]="true" [allowExportSelectedData]="false"></dxo-export>
  <dxo-group-panel [visible]="true"></dxo-group-panel>

  <!--  RECHERCHE FRONT-->
  <dxo-search-panel [visible]="true"></dxo-search-panel>

  <!--  SORTING-->
  <dxo-sorting mode="multiple"></dxo-sorting>

  <!--  LIBELLE CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'libelleCellTemplate'">
    <span>{{ cell.row.data.libelle  | uppercase }}</span>
    <div>
      <yo-gef-audit-button
        [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditList, cell.row.data.id)">
      </yo-gef-audit-button>
    </div>
  </div>


  <!--  DLC CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'dlcCellTemplate'">
    J+{{ cell.row.data.dlc  }}
  </div>

  <!--  UNITE DE MESURE CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'uniteDeMesureCellTemplate'">
    {{ cell.row.data.uniteDeMesure.libelle}}
  </div>

  <!--  PRIX ACHAT CELL TEMPLATE-->
  <!--  <div *dxTemplate="let cell of 'prixAchatCellTemplate'">-->
  <!--    {{ cell.row.data.prixAchat | currency:'EUR':'symbol':'1.4-4' }}-->
  <!--  </div>-->

  <!--  DECLINAISON CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'declinaisonCellTemplate'">
    <label class="badge badge-secondary cursor" (click)="openEditObject(produit, cell.row.data)">
      {{cell.row.data.declinaison.libelle | uppercase}}
    </label>
  </div>

  <!--  ACTIONS CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openEditObject(produit, cell.row.data)"
                    iconClass="fa fa-edit"
                    tooltip="Modifier la déclinaison"
    ></yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" (onClick)="openDeleteObject(cell.row.data)"
                    iconClass="fa fa-trash"
                    tooltip="Supprimer la déclinaison"
    ></yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.SECONDARY_INNER" (onClick)="printIncoData(cell.row.data)"
                    iconClass="far fa-file-pdf"
                    tooltip="Exporter la fiche inco"
    ></yo-button>
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.SECONDARY_INNER" (onClick)="openDialogDuplicationDeclinaison(produit, cell.row.data)"
                    iconClass="fas fa-copy"
                    tooltip="Dupliquer la déclinaison"
                    [disabled]="!canDuplicateDeclinaison(cell.row.data)"
    ></yo-button>
    <ng-container *ngIf="!cell.row.data.fabrique">
      <yo-button size="small"
                    [theme]="ButtonThemeEnum.SECONDARY_INNER" (onClick)="openDialogPlatUsingSelectedDenree(cell.row.data)"
                      iconClass="fas fa-th-list"
                      tooltip="Voir les plats utilisant cette denrée"
      ></yo-button>
    </ng-container>
  </div>
</dx-data-grid>

<p-dialog
  [(visible)]="displayDialog"
  [contentStyle]="{'overflow':'visible'}"
  [modal]="true"

  (onHide)="onHideDuplicationDialog()"
  [style]="{width: '800px', minWidth: '800px'}"
  [dismissableMask]="false">

  <!--HEADER-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-copy mg-r-5"></i>{{getTitre()}}
    </div>
  </ng-template>


  <!--CONTENT-->
  <div class="row">
    <!--SELECTION CONVIVES-->
    <div class="col-md-auto cursor">
      <p-multiSelect [options]="allDeclinaisons"
                     [(ngModel)]="selectedDeclinaisons"
                     optionLabel="libelle"
                     defaultLabel="Choisir une ou plusieurs déclinaisons cibles"
                     (onChange)="changeDeclinaison($event)"
      >

      </p-multiSelect>

    </div>
  </div>


  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <yo-button (onClick)="duplicationDeclinaison()" iconClass="fas fa-copy"
      [theme]="ButtonThemeEnum.DEFAULT" label="Copier"
               [disabled]="!canDuplicateDeclinaisonDialog()"></yo-button>
    <yo-button (onClick)="onHideDuplicationDialog()" iconClass="fas fa-times"
      [theme]="ButtonThemeEnum.CANCEL"
               label="Fermer"></yo-button>
  </ng-template>

</p-dialog>


<!--DIALOG DE CREATION / MODIFICATION D'UN PRODUIT DECLINAISON-->
<yo-declinaison-produit-dialog-edit [denree]="!produit.typeProduit.fabrique"
                                     (deleted)="onDeclinaisonDeleted($event)"></yo-declinaison-produit-dialog-edit>

<!--DIALOG LISTE PLAT-->
<yo-dialoglistplat></yo-dialoglistplat>

<yo-dialog-gef-audit></yo-dialog-gef-audit>
